import { render, staticRenderFns } from "./authGroupMenu.vue?vue&type=template&id=0c4c4915"
import script from "./authGroupMenu.vue?vue&type=script&lang=js"
export * from "./authGroupMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4c4915')) {
      api.createRecord('0c4c4915', component.options)
    } else {
      api.reload('0c4c4915', component.options)
    }
    module.hot.accept("./authGroupMenu.vue?vue&type=template&id=0c4c4915", function () {
      api.rerender('0c4c4915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/auth/authGroupMenu.vue"
export default component.exports